
const routes = {
    api: {
        cart: {
            testing: 'api/Cart/Testing',
        },
        logging: {
            logError: 'api/Logging/Log',
        },
        sandbox: {
            throwError: 'api/Sandbox/ThrowError'
        }
    },
    web: {
        cart: '/Cart',
        sandbox: {
            throwError: '/Sandbox/ThrowError',
        }
    }
}

export { routes };